const search = () => {

    const active_class = "active";
    const $form = jQuery(".header-form-search form.form-search");
    const $input = $form.find('input');
    const $btn_submit = $form.find('button[type="submit"]');

    $btn_submit.click(function (event) {

        // If input hidden, show it

        if (!$form.hasClass(active_class)) {

            $form.addClass(active_class);

            event.preventDefault();

            $input.focus();

        } 

        // If input is empty, hide it

        else {

            if ($input.val().length < 2) {

                $form.removeClass(active_class);

                event.preventDefault();

            }
            else {

                $form.submit();

            }

        }

    });



    $input.focusout(function (event) {

        if (!$btn_submit.is(":hover")) {

            $form.removeClass(active_class);

        }

    });

};